module.exports = __webpack_public_path__ + "static/img/dili.ecdd847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/dili.png
// module id = hqua
// module chunks = 0